/** PACS converter status enum */
export enum ConverterStatusEnum {
  /** Converter not connected yet */
  NOT_CONNECTED = 'NOT_CONNECTED',
  /** Converter online */
  ONLINE = 'ONLINE',
  /** Converter offline */
  OFFLINE = 'OFFLINE',
}
